import { index, sqliteTable, text } from 'drizzle-orm/sqlite-core'

import { id, timestamps } from './_columns'
import { sites } from './sites'

/** One build-and-deploy of a site's public web. */
export const siteBuilds = sqliteTable(
  'site_builds',
  {
    id: id(),
    siteId: text('site_id')
      .notNull()
      .references(() => sites.id, { onDelete: 'cascade' }),
    /** `queued | running | succeeded | failed | skipped`. */
    status: text('status').notNull().default('queued'),
    /**
     * `manual` (staff pressed Rebuild), `cms` (the site asked for one after a content change), `code` (a code change on
     * main, requested by the workflow) or `pipeline` (a run the console did not start, reported by the workflow).
     */
    trigger: text('trigger').notNull().default('manual'),
    requestedBy: text('requested_by'),
    /** The CI run this build belongs to, once the pipeline reports it. */
    externalRunId: text('external_run_id'),
    message: text('message'),
    finishedAt: text('finished_at'),
    ...timestamps,
  },
  (t) => [index('ix_site_builds_site').on(t.siteId, t.createdAt)],
)

export type SiteBuildRow = typeof siteBuilds.$inferSelect
